export type { LogoProps } from './types';

export {
	AdminIcon,
	AdminIcon as AtlassianAdminIcon,
	AdminIcon as AtlassianAdministrationIcon,
} from './artifacts/logo-components/admin/icon';
export {
	AdminLogoCS as AdminLogo,
	AdminLogoCS as AtlassianAdminLogo,
	AdminLogoCS as AtlassianAdministrationLogo,
} from './artifacts/logo-components/admin/logo-cs';
export { AlignIcon, AlignIcon as JiraAlignIcon } from './artifacts/logo-components/align/icon';
export {
	AlignLogoCS as AlignLogo,
	AlignLogoCS as JiraAlignLogo,
} from './artifacts/logo-components/align/logo-cs';
export {
	AnalyticsIcon,
	AnalyticsIcon as AtlassianAnalyticsIcon,
} from './artifacts/logo-components/analytics/icon';
export {
	AnalyticsLogoCS as AnalyticsLogo,
	AnalyticsLogoCS as AtlassianAnalyticsLogo,
} from './artifacts/logo-components/analytics/logo-cs';
export { AssetsIcon } from './artifacts/logo-components/assets/icon';
export { AssetsLogoCS as AssetsLogo } from './artifacts/logo-components/assets/logo-cs';
export { BambooIcon } from './artifacts/logo-components/bamboo/icon';
export { BambooLogoCS as BambooLogo } from './artifacts/logo-components/bamboo/logo-cs';
export { BitbucketIcon } from './artifacts/logo-components/bitbucket/icon';
export { BitbucketLogoCS as BitbucketLogo } from './artifacts/logo-components/bitbucket/logo-cs';
export { BitbucketDataCenterIcon } from './artifacts/logo-components/bitbucket-data-center/icon';
export { BitbucketDataCenterLogoCS as BitbucketDataCenterLogo } from './artifacts/logo-components/bitbucket-data-center/logo-cs';
export { ChatIcon } from './artifacts/logo-components/chat/icon';
export { ChatLogoCS as ChatLogo } from './artifacts/logo-components/chat/logo-cs';
export { CompanyHubIcon } from './artifacts/logo-components/company-hub/icon';
export { CompanyHubLogo } from './artifacts/logo-components/company-hub/logo';
export { CompassIcon } from './artifacts/logo-components/compass/icon';
export { CompassLogoCS as CompassLogo } from './artifacts/logo-components/compass/logo-cs';
export { ConfluenceIcon } from './artifacts/logo-components/confluence/icon';
export { ConfluenceLogoCS as ConfluenceLogo } from './artifacts/logo-components/confluence/logo-cs';
export { ConfluenceDataCenterIcon } from './artifacts/logo-components/confluence-data-center/icon';
export { ConfluenceDataCenterLogoCS as ConfluenceDataCenterLogo } from './artifacts/logo-components/confluence-data-center/logo-cs';
export { CrowdIcon } from './artifacts/logo-components/crowd/icon';
export { CrowdLogoCS as CrowdLogo } from './artifacts/logo-components/crowd/logo-cs';
export { CustomLinkIcon } from './artifacts/logo-components/custom-link/icon';
export { CustomerServiceManagementIcon } from './artifacts/logo-components/customer-service-management/icon';
export { CustomerServiceManagementLogoCS as CustomerServiceManagementLogo } from './artifacts/logo-components/customer-service-management/logo-cs';
export { DxIcon } from './artifacts/logo-components/dx/icon';
export { FeedbackIcon } from './artifacts/logo-components/feedback/icon';
export { FeedbackLogoCS as FeedbackLogo } from './artifacts/logo-components/feedback/logo-cs';
export { FocusIcon } from './artifacts/logo-components/focus/icon';
export { FocusLogoCS as FocusLogo } from './artifacts/logo-components/focus/logo-cs';
export { GoalsIcon } from './artifacts/logo-components/goals/icon';
export { GoalsLogoCS as GoalsLogo } from './artifacts/logo-components/goals/logo-cs';
export { GuardIcon } from './artifacts/logo-components/guard/icon';
export { GuardLogoCS as GuardLogo } from './artifacts/logo-components/guard/logo-cs';
export { GuardDetectIcon } from './artifacts/logo-components/guard-detect/icon';
export { GuardDetectLogo } from './artifacts/logo-components/guard-detect/logo';
export { HomeIcon } from './artifacts/logo-components/home/icon';
export { HomeLogoCS as HomeLogo } from './artifacts/logo-components/home/logo-cs';
export { HubIcon } from './artifacts/logo-components/hub/icon';
export { HubLogoCS as HubLogo } from './artifacts/logo-components/hub/logo-cs';
export { JiraIcon } from './artifacts/logo-components/jira/icon';
export { JiraLogoCS as JiraLogo } from './artifacts/logo-components/jira/logo-cs';
export { JiraCodingAgentIcon } from './artifacts/logo-components/jira-coding-agent/icon';
export { JiraDataCenterIcon } from './artifacts/logo-components/jira-data-center/icon';
export { JiraDataCenterLogoCS as JiraDataCenterLogo } from './artifacts/logo-components/jira-data-center/logo-cs';
export { JiraProductDiscoveryIcon } from './artifacts/logo-components/jira-product-discovery/icon';
export { JiraProductDiscoveryLogoCS as JiraProductDiscoveryLogo } from './artifacts/logo-components/jira-product-discovery/logo-cs';
export { JiraServiceManagementIcon } from './artifacts/logo-components/jira-service-management/icon';
export { JiraServiceManagementLogoCS as JiraServiceManagementLogo } from './artifacts/logo-components/jira-service-management/logo-cs';
export { JiraServiceManagementDataCenterIcon } from './artifacts/logo-components/jira-service-management-data-center/icon';
export { JiraServiceManagementDataCenterLogoCS as JiraServiceManagementDataCenterLogo } from './artifacts/logo-components/jira-service-management-data-center/logo-cs';
export { LoomIcon, LoomIcon as LoomAttributionIcon } from './artifacts/logo-components/loom/icon';
export { LoomLogoCS as LoomLogo } from './artifacts/logo-components/loom/logo-cs';
export { LoomAttributionLogoCS as LoomAttributionLogo } from './artifacts/logo-components/loom-attribution/logo-cs';
export { LoomInternalIcon as LoomBlurpleIcon } from './artifacts/logo-components/loom-internal/icon';
export { LoomInternalLogoCS as LoomBlurpleLogo } from './artifacts/logo-components/loom-internal/logo-cs';
export { MoreAtlassianAppsIcon } from './artifacts/logo-components/more-atlassian-apps/icon';
export { OpsgenieIcon } from './artifacts/logo-components/opsgenie/icon';
export { OpsgenieLogoCS as OpsgenieLogo } from './artifacts/logo-components/opsgenie/logo-cs';
export { ProjectsIcon } from './artifacts/logo-components/projects/icon';
export { ProjectsLogoCS as ProjectsLogo } from './artifacts/logo-components/projects/logo-cs';
export { RovoIcon } from './artifacts/logo-components/rovo/icon';
export { RovoLogoCS as RovoLogo } from './artifacts/logo-components/rovo/logo-cs';
export { RovoDevIcon } from './artifacts/logo-components/rovo-dev/icon';
export { RovoDevLogoCS as RovoDevLogo } from './artifacts/logo-components/rovo-dev/logo-cs';
export { RovoDevAgentIcon } from './artifacts/logo-components/rovo-dev-agent/icon';
export { RovoDevAgentLogoCS as RovoDevAgentLogo } from './artifacts/logo-components/rovo-dev-agent/logo-cs';
export { SearchIcon } from './artifacts/logo-components/search/icon';
export { SearchLogoCS as SearchLogo } from './artifacts/logo-components/search/logo-cs';
export { StatuspageIcon } from './artifacts/logo-components/statuspage/icon';
export { StatuspageLogoCS as StatuspageLogo } from './artifacts/logo-components/statuspage/logo-cs';
export { StudioIcon } from './artifacts/logo-components/studio/icon';
export { StudioLogoCS as StudioLogo } from './artifacts/logo-components/studio/logo-cs';
export { TalentIcon } from './artifacts/logo-components/talent/icon';
export { TalentLogoCS as TalentLogo } from './artifacts/logo-components/talent/logo-cs';
export { TeamsIcon } from './artifacts/logo-components/teams/icon';
export { TeamsLogoCS as TeamsLogo } from './artifacts/logo-components/teams/logo-cs';
export { TrelloIcon } from './artifacts/logo-components/trello/icon';
export { TrelloLogoCS as TrelloLogo } from './artifacts/logo-components/trello/logo-cs';
export { AtlasIcon } from './legacy-logos/atlas/icon';
export { AtlasLogo } from './legacy-logos/atlas/logo';
export { AtlassianAccessIcon } from './legacy-logos/atlassian-access/icon';
export { AtlassianAccessLogo } from './legacy-logos/atlassian-access/logo';
export { AtlassianMarketplaceIcon } from './legacy-logos/atlassian-marketplace/icon';
export { AtlassianMarketplaceLogo } from './legacy-logos/atlassian-marketplace/logo';
export { AtlassianIcon } from './legacy-logos/atlassian/icon';
export { AtlassianLogo } from './legacy-logos/atlassian/logo';
export { JiraSoftwareIcon } from './legacy-logos/jira-software/icon';
export { JiraSoftwareLogo } from './legacy-logos/jira-software/logo';
export { JiraWorkManagementIcon } from './legacy-logos/jira-work-management/icon';
export { JiraWorkManagementLogo } from './legacy-logos/jira-work-management/logo';
